import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';
import TransferIcon from '@app/images/transfer.svg';
import ArrowsIcon from '@app/images/arrows.svg';
import config from '@app/config';

export const PingPongCADTwentyFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.pingPongCADTwenty.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'ABA Fedwire',
      value: '026009593',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America, 222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  highlightedInstructions: {
    additionalItems: [
      'supplierValidation.afterRegister.pingPongCADTwenty.firstHighlightedInstruction',
      'supplierValidation.afterRegister.pingPongCADTwenty.secondHighlightedInstruction',
    ],
  },
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.pingPongCADTwenty.firstNote',
      'supplierValidation.afterRegister.pingPongCADTwenty.secondNote',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: true,
    swiftWireTransfer: false,
  },
  extraInstructions: [
    { icon: TransferIcon, text: 'supplierValidation.afterRegister.pingPongCADTwenty.step1' },
    { icon: ArrowsIcon, text: 'supplierValidation.afterRegister.pingPongCADTwenty.step2' },
  ],
  downloadLink: `${config.supplierValidationAttachmentsUrl}PingPongCADTwenty/en/nium-cad-20.pdf`,
};
